<template>
	<div>
		<div class="f-tools" ref="tools"  :style=" { width :(width+20)+'px' }">
			<div class="f-button">
				<template v-if="isServer">
					<div class="f-button-item iconfont icon-picfill" @click="server_show_hide(true,'image')"></div>
					<div class="f-button-item iconfont icon-video-fill" @click="server_show_hide(true,'video')"></div>
				</template>
				<template v-if="!isServer">
					<el-upload style="padding: 0; margin: 0;" :show-file-list="false" :http-request="f_edit_upload"><div class="f-button-item iconfont icon-picfill"></div></el-upload>
				</template>
			</div>
		</div>
		<div class="f-edit" ref="editor" :style=" { height :height+'px', width :width+'px' }"></div>
		<layer-pop title="请选择图片" v-if="is_server" @close="server_show_hide(false)">
			<div class="server-wrap">
				<div class="server-select iconfont icon-back" v-if="dir" @click="dir_change('')"></div>
				<div class="server-option" v-for="(val,key) in list" :key="key">
					<template v-if="server_type=='image'">
						<template v-if="val.is_dir">
							<el-tooltip>
								<div slot="content">名称：{{val.name}}<br/>创建时间：{{val.time}}</div>
								<div class="server-select iconfont icon-file" @click="dir_change(val.name)">
									<div class="server-select-name">{{val.name}}</div>
								</div>
							</el-tooltip>
						</template>
						<template v-if="!val.is_dir">
							<el-tooltip>
								<div slot="content">名称：{{val.name}}<br/>创建时间：{{val.time}}<br/>大小：{{val.size}}KB</div>
								<div class="server-select" @click="f_edit_choose(val.url)">
									<img :src="val.url" alt="">
								</div>
							</el-tooltip>
						</template>
					</template>
					
					<template v-if="server_type=='video'">
						<template v-if="val.is_dir">
							<el-tooltip>
								<div slot="content">名称：{{val.name}}<br/>创建时间：{{val.time}}</div>
								<div class="server-select iconfont icon-file" @click="dir_change(val.name)">
									<div class="server-select-name">{{val.name}}</div>
								</div>
							</el-tooltip>
						</template>
						<template v-if="!val.is_dir">
							<el-tooltip>
								<div slot="content">名称：{{val.name}}<br/>创建时间：{{val.time}}<br/>大小：{{val.size}}KB</div>
								<div class="server-select iconfont icon-video-fill" @click="f_edit_choose(val.url)">
									<div class="server-select-name">{{val.name}}</div>
								</div>
							</el-tooltip>
						</template>
					</template>
				</div>
			</div>
			<div class="server-choose-button">
				<div class="server-choose">
					<template v-if="server_type=='image'">
						<div class="server-choose-item" v-for="(val,key) in choose_list" :key="key" @click="f_edit_choose(val)" :title="val">
							<img :src="val" alt="">
						</div>
					</template>
					<template v-if="server_type=='video'">
						<div class="server-choose-item iconfont icon-video-fill" v-for="(val,key) in choose_list" :key="key" @click="f_edit_choose(val)" :title="val"></div>
					</template>
				</div>
				<div class="server-button">
					<el-upload :show-file-list="false" :http-request="server_upload">
						<el-button type="success" class="server-button-upload mr-20">上传</el-button>
					</el-upload>
					<el-button type="primary" class="server-button-confirm" @click="f_edit_choose_confirm">确定选择</el-button>
				</div>
			</div>
		</layer-pop>
		
	</div>
</template>

<script>
	import E from 'wangeditor';
	import LayerPop from "@/components/layer-pop";
	export default {
		name : "f-edit",
		model : {prop:'content', event:'change'},
		components : {LayerPop},
		props : {
			excludeMenus : { type : Array, default: function  (){
					return [
						'todo',
						'code',
						'emoticon',
						'image',
						'video',
						'undo',
						'redo',
						'table'
					];
				}},
			isFullScreen : { type : Boolean, default : false },
			maxSize : {type : Number, default : 10},
			height : {type : Number, default : 400},
			width : {type : Number, default : 700},
			port : {type : String, default:'upload'},
			imageMethod : {type : String, default:'image_list'},
			videoMethod : {type : String, default:'video_list'},
			content : {type : String, default : ''},
			isServer : {type : Boolean, default : true},
		},
		data (){
			return {
				is_server : false,
				server_type : 'image',
				is_load : false,
				dir : '',
				list : [],
				choose_list : [],
			}
		},
		mounted : async function (){
			try{
				await this.create();
				console.log(this.content,'643123166541313')
			}catch (e){
				console.log(e);
				return false;
			}
		},
		computed : {
			editor : function  (){
				return new E(this.$refs.tools,this.$refs.editor);
			},
		},
    watch : {
      content : function  (value){
        console.log(value,'watch-content');
        console.log(this.editor.txt.html(),'watch-html');
        if (value != this.editor.txt.html()) {
          this.editor.txt.html(value)
        }
      },
    },
		// watch : {
		// 	content : function  (value){
		// 		console.log(value,'watch-content');
		// 		console.log(this.editor.txt.html(),'watch-html');
		// 		if (value != this.editor.txt.html()) {
		// 			// this.editor.txt.html(value)
    //       this.$emit('change',html);
    //     }
		// 	},
		// },
		methods : {
			create : async function (){
				let that = this;
				let editor = this.editor;
				// editor = new E(this.$refs.tools,this.$refs.editor);
				//配置不要菜单
				editor.config.excludeMenus = this.excludeMenus;
				//是否显示全部屏
				editor.config.showFullScreen = this.isFullScreen;
				//关闭使用base64保存图片
				editor.config.uploadImgShowBase64 = false;
				editor.config.height = this.height;
				editor.config.placeholder = '请填写内容';
				editor.config.zIndex = 999;
				editor.config.onchange = function  (html){
					that.$emit('change',html);
				};
				editor.create();
				console.log(this.content);
        editor.txt.html(this.content)
			},
			//显示图片选择
			server_show_hide: async function  (show,type){
				console.log(show);
				if (show){
					this.is_server = true;
					this.server_type = type;
					await this.server_get_list();
				}else{
					this.is_server = false;
					this.dir = '';
					this.list = [];
					this.is_load = false;
					this.choose_list = [];
				}
			},
			dir_change : async function  (dir){
				try{
					this.dir = dir;
					this.list = [];
					this.is_load = false;
					await this.server_get_list();
				}catch (e){
					console.log(e);
					return false;
				}
			},
			f_edit_choose : function  (url){
				console.log(url);
				let choose_list = this.choose_list;
				let check = this.$tools.in_array(choose_list,url);
				if (check > -1){
					choose_list = this.$tools.unset(choose_list,check);
				}else{
					choose_list.push(url);
				}
				this.choose_list = choose_list;
			},
			f_edit_choose_confirm : function  (){
				let that = this;
				let choose_list = this.choose_list;
				let type = this.server_type;
				console.log(that.editor);
				if (choose_list.length>0){
					choose_list.forEach(function  (val){
						if (type == 'image'){
							// that.editor.txt.append('<img src="'+val+'" alt="'+val+'"/>')
              that.editor.cmd.do('insertHTML', '<img src="'+val+'" alt="'+val+'"/>')
						}else{
							// that.editor.txt.append('<video src="'+val+'" style="max-width: 100%; min-height: 300px;"></video>')
              that.editor.cmd.do('insertHTML', '<video src="'+val+'" style="max-width: 100%; min-height: 300px;"></video>')

            }
					});
					this.server_show_hide(false);
				}
			},
			f_edit_upload : async function  (e){
				if (e.file){
					this.$_showLoading('上传中');
					let res = await this.$_api.upload(e.file);
					this.$_hideLoading();
					if (res.errcode == 0){
						// this.editor.txt.append('<img src="'+res.url+'" alt="'+res.name+'"/>')
            this.editor.cmd.do('insertHTML', '<img src="'+res.url+'" alt="'+res.name+'"/>')

          }else{
						this.$_showToastNone('上传失败')
					}
				}
			},
			server_upload : async function  (e){
				if (!e.file){
					this.$_showToastNone('无选择文件');
					return;
				}
				this.$_showLoading();
				let res = await this.$_request.upload(e.file, this.dir);
				this.$_hideLoading();
				if (res.errcode == 0){
					await this.server_get_list();
				}else{
					this.$_showToastNone('上传失败');
				}
			},
			server_get_list : async function  (){
				try{
					if (!this.is_load){
						this.is_load = true;
						this.$_showLoading();
						let res;
						if (this.server_type == 'image'){
							res = await this.$_request.post(this.port, this.imageMethod, {dir : this.dir});
						}else{
							res = await this.$_request.post(this.port, this.videoMethod,{dir : this.dir});
						}
						this.is_load = false;
						this.$_hideLoading();
						if (res.errcode == 0){
							this.list = res.list;
						}else{
							this.$_showToastNone(res.errmsg);
						}
					}
				}catch (e){
					console.log(e);
					return false;
				}
			},
		},
	}
</script>

<style scoped>
	.f-tools { border: 1px solid #dcdfe6; }
	
	.f-button { padding: 0 6px; }
	.f-button:after { content: ''; display: table; clear: both; }
	.f-button-item { float: left; width: 40px; height: 40px; line-height: 40px; text-align: center; color: #999999; cursor: pointer; }
	.f-button-item:hover { color: #2c2c2c; background: #f2f2f2; }
	
	.f-edit { border: 1px solid #dcdfe6; border-top: none; overflow-y: auto; overflow-x: hidden; padding: 20px 10px; }
	.f-edit img { max-width: 100%; }
	
	.server-wrap { width: 860px; height: 550px; overflow-x: hidden; overflow-y: auto; }
	.server-wrap:after { content: ''; display: table; clear: both; }
	.server-select { float: left; width: 100px; height: 100px; border-radius: 5px; border: 1px solid #dcdfe6; margin-left: 10px ;margin-bottom: 10px; cursor: pointer; line-height: 100px; text-align: center; font-size: 30px; color: #999999; position: relative; overflow: hidden; }
	.server-select-name { position: absolute; left: 0; right: 0; bottom:0; height: 30px; line-height: 30px; font-size: 12px; background: rgba(0,0,0,0.5); color: #ffffff; padding: 0 10px; overflow: hidden; white-space: nowrap; text-overflow:ellipsis; }
	.server-option { float: left; }
	.server-select img { width: 100%; display: block; margin-top: 50%; transform: translateY(-50%); }
	.server-select:hover { border-color: #5dbb85; box-shadow: 0 0 5px #999999; }
	.server-select.cursor { border-color: #5dbb85; box-shadow: 0 0 5px #999999; }
	
	.server-choose-button { padding-top: 20px; height: 40px; display: flex; }
	.server-choose { padding-right: 20px; flex: 1; overflow-x: auto; overflow-y: hidden; }
	.server-choose:after { content: ''; display: table; clear: both; }
	.server-choose-item { width: 40px; height: 40px; text-align: center; line-height: 40px; overflow: hidden; margin-right: 10px; box-sizing: border-box; border: 1px solid #5dbb85; float: left; border-radius: 5px; cursor: pointer; }
	.server-choose-item img { width: 100%; margin-top: 50%; transform: translateY(-50%); }
	.server-button { display: flex; }
	.server-button-upload,.server-button-confirm { height: 40px; }
	
</style>
